import { render, staticRenderFns } from "./ListadoDetallesPagosUniversidades.vue?vue&type=template&id=f1c2bb1a"
import script from "./ListadoDetallesPagosUniversidades.vue?vue&type=script&lang=js"
export * from "./ListadoDetallesPagosUniversidades.vue?vue&type=script&lang=js"
import style0 from "./ListadoDetallesPagosUniversidades.vue?vue&type=style&index=0&id=f1c2bb1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports